import type { ReactNode } from 'react';
import React from 'react';

import Hero from 'Components/StaticPages/ProductPageComponents/Hero/Hero';

import heroAvif from './images/move-hero.avif';
import heroPng from './images/move-hero.png';
import heroWebp from './images/move-hero.webp';

export type HeroSectionProps = {
	actions: ReactNode;
	hasStickyButtons: boolean;
	ref: React.Ref<HTMLDivElement>;
};

export const HeroSection = React.forwardRef<HTMLDivElement, HeroSectionProps>((props, ref) => {
	return (
		<Hero
			ref={ref}
			buttons={<div data-sticky={props.hasStickyButtons ? 'true' : undefined}>{props.actions}</div>}
			image={{
				avif: heroAvif.src,
				height: heroPng.height,
				png: heroPng.src,
				webp: heroWebp.src,
				width: heroPng.width,
			}}
			subtitle="Get stock on your forecourt faster with our all-in collection and appraisal service."
			title={
				<>
					From their door to yours. <br />
					<strong>Delivery, sorted.</strong>
				</>
			}
		/>
	);
});
